import React from 'react'
import styles from './svg.module.scss'

const CircleCheck = ({
  viewBox = '0 0 24 24',
  size = 24,
  color = 'primaryColor',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={viewBox}
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={styles[`${color}Stroke`]}
      style={{ fill: 'none' }}
    >
      <circle cx="12" cy="12" r="10" />
      <path d="m9 12 2 2 4-4" />
    </svg>
  )
}

export default CircleCheck
